(() => {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const viewport = root.querySelector('.lj-carousel__viewport');
    const track = root.querySelector('.lj-carousel__track');
    const items = [...track.children];
    if (items.length < 2) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const pause = root.querySelector('[data-pause]');
    let paused = reduced.matches, focused = false, interacting = false, visible = false;
    let timer, settling, index = 0;
    const copies = Math.min(4, items.length);
    const clone = item => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.removeAttribute('role');
      copy.removeAttribute('aria-label');
      return copy;
    };
    items.slice(-copies).reverse().forEach(item => track.prepend(clone(item)));
    items.slice(0, copies).forEach(item => track.append(clone(item)));
    const step = () => items[1].offsetLeft - items[0].offsetLeft;
    const start = () => items[0].offsetLeft - track.offsetLeft;
    const jump = () => { viewport.scrollLeft = start() + index * step(); };
    function schedule() {
      clearTimeout(timer);
      if (!paused && !focused && !interacting && visible && !document.hidden) {
        timer = setTimeout(() => {
          index = Math.round((viewport.scrollLeft - start()) / step()) + 1;
          viewport.scrollTo({left: start() + index * step(), behavior: reduced.matches ? 'instant' : 'smooth'});
        }, 3000);
      }
    }
    viewport.addEventListener('scroll', () => {
      clearTimeout(timer);
      clearTimeout(settling);
      settling = setTimeout(() => {
        index = Math.round((viewport.scrollLeft - start()) / step());
        if (index >= items.length || index < 0) {
          index = (index % items.length + items.length) % items.length;
          jump();
        }
        schedule();
      }, 160);
    }, {passive: true});
    function updatePause() {
      pause.setAttribute('aria-pressed', String(paused));
      pause.textContent = paused ? 'Reanudar carrusel' : 'Pausar carrusel';
      schedule();
    }
    pause.addEventListener('click', () => { paused = !paused; focused = false; updatePause(); });
    root.addEventListener('focusin', event => {
      focused = event.target !== pause && event.target.matches(':focus-visible');
      schedule();
    });
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget)) { focused = false; schedule(); }
    });
    viewport.addEventListener('pointerdown', () => { interacting = true; clearTimeout(timer); }, {passive: true});
    function release() {
      if (interacting) { interacting = false; schedule(); }
    }
    window.addEventListener('pointerup', release, {passive: true});
    window.addEventListener('pointercancel', release, {passive: true});
    window.addEventListener('blur', release);
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', () => { paused = reduced.matches; updatePause(); });
    new IntersectionObserver(entries => {
      const next = entries[0].isIntersecting;
      if (visible !== next) { visible = next; schedule(); }
    }, {threshold: 0}).observe(viewport);
    new ResizeObserver(jump).observe(viewport);
    requestAnimationFrame(jump);
    updatePause();
  }
  function init(scope = document) { scope.querySelectorAll('[data-lj-carousel]').forEach(setup); }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
